import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prefixSuffix',
})
export class PrefixSuffixPipe implements PipeTransform {

  transform(value: number | string, prefix: string, suffix: string, isNullDash: boolean): string {
    const zeroValue = value === 0 || value === null || value === undefined || value === Infinity || isNaN(Number(value));
    if (isNullDash && prefix !== 'x' && suffix !== '%' && Math.abs(Number(value)) < 1000) return '-';
    if (zeroValue) {
      return isNullDash ? '-' : (prefix + '0.00' + suffix).toString();
    }
    if (value) {
      value = Number(value);
      if (value >= 1e12) return 'Too high';
      if (value >= 1e9) return prefix + (value / 1e9).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'B' + suffix;
      if (value >= 1e5) return prefix + (value / 1e6).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M' + suffix;
      if (value >= 1e3) return prefix + (value / 1e3).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'K' + suffix;
      if (value < 1000 && value > 0) return prefix + value.toFixed(2) + suffix;
      if (value > -1000 && value < 0) return '(' + prefix + (-value).toFixed(2) + suffix + ')';
      if (value <= -1e9) return '(' + prefix + (-value / 1e9).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'B' + suffix + ')';
      if (value <= -1e5) return '(' + prefix + (-value / 1e6).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M' + suffix + ')';
      if (value <= -1e3) return '(' + prefix + (-value / 1e3).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'K' + suffix + ')';
      return prefix + value.toString() + suffix;
    }
  }

}
